// Auto-generated skeleton for TicketType

export const TicketType: Api.TicketType = {
  id: 0,
  hp_id: null,
  name: '',
  created: null,
  updated: null,
};

